import { DarwinDivider } from 'components/darwin-ui';
import { EditableText } from './EditableText';
import styles from './DataCapture.module.css';

type FormNameSectionProps = {
  isViewForm: boolean;
};

export const FormNameSection = ({ isViewForm }: FormNameSectionProps) => {
  return (
    <>
      <div className={styles.sectionContainer}>
        <EditableText
          isViewForm={isViewForm}
          fieldName={'formName'}
          textClassnames={styles.formNameSectionTitle}
        />
        <DarwinDivider className={styles.titleDivider} />
        <EditableText
          isViewForm={isViewForm}
          fieldName={'formDescription'}
          textClassnames={styles.formDescriptionTitle}
        />
      </div>
    </>
  );
};
